import { Link } from '@inertiajs/react';
import { useCallback } from 'react';
import { openChat } from '../utils/chat';

export function Footer() {
    const handleOpenChat = useCallback(() => {
        openChat();
    }, []);

    return (
        <footer className="hidden md:block border-t border-gray-200 bg-gray-50 py-6 mt-auto">
            <div className="mx-auto max-w-6xl px-4">
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-600">
                    <button
                        type="button"
                        onClick={handleOpenChat}
                        className="hover:text-gray-900 transition-colors"
                    >
                        Contactános
                    </button>
                    <span className="hidden sm:inline text-gray-300">|</span>
                    <Link
                        href="/politicas"
                        className="hover:text-gray-900 transition-colors"
                    >
                        Políticas
                    </Link>
                </div>
            </div>
        </footer>
    );
}
